module.exports = {
	"articleTitle1": "Hunter House to open new Ann Arbor location",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Hunter House",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/pocket-points-offers-students-incentives-stay-phones-class",
	"articleSnippet1": "Mar 23, 2014 ... After more than 60 years of serving classic diner food in Birmingham, Hunter \nHouse Hamburgers is set to open its second location near Central ...",
	"articleSnippet2": "Feb 10, 2015 ... The restaurants currently included are Pita Pit, The Brown Jug, The Blue \nLeprechaun, Comet Coffee, Get Some Burritos, Hunter House ...",
	"foodRecommendations": [
		{
			"text": "The chicken and waffle sandwiches and greasy burgers are really great after you've had a long night of \"studying\"",
			"person": "Nick Kortman"
		},
		{
			"text": "It's pretty good. They have smaller burgers. It's a little overpriced for what it is though.",
			"person": "Charlie Ruiz"
		}
	],
	"articleTitle2": "Pocket Points application encourages student attention during class",
	"address": "609 E William St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278004,
		"lng": -83.741534
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/hunterhouse.json
// module id = 893
// module chunks = 0